import { render, staticRenderFns } from "./EsgProtocolDetail.vue?vue&type=template&id=336120e0&scoped=true"
import script from "./EsgProtocolDetail.vue?vue&type=script&lang=js"
export * from "./EsgProtocolDetail.vue?vue&type=script&lang=js"
import style0 from "./EsgProtocolDetail.vue?vue&type=style&index=0&id=336120e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336120e0",
  null
  
)

export default component.exports